// src/config.js
const config = {
  showSponsors: false,
  showCharities: false,

};

export default config;
